import { render } from "./PayStatusTemplate.vue?vue&type=template&id=12d99e98&scoped=true"
import script from "./PayStatusTemplate.vue?vue&type=script&lang=js"
export * from "./PayStatusTemplate.vue?vue&type=script&lang=js"

import "./PayStatusTemplate.vue?vue&type=style&index=0&id=12d99e98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d99e98"]])

export default __exports__